/** Full Store page. Same teamStores id. Drawer is not the detail view. */
export function storePath(storeId: string): string {
  return `/store/${encodeURIComponent(storeId)}`;
}
